import { z } from 'zod'

/**
 * How far along the site's map is. Mirrors `SiteMapStatus` in
 * prisma/schema.prisma.
 *
 * A map of the client's own site gets drawn at some point before or after the
 * work is won, and knowing which sites still need one is operational
 * information — so this is tracked per site rather than inferred from whether a
 * map file happens to be attached.
 *
 * Note this is STORED rather than derived (unlike an invite's status, which is
 * computed from its timestamps): IN_PROGRESS is a human assertion with no
 * artifact behind it, so there is nothing to derive it from.
 */
export const SITE_MAP_STATUSES = ['NONE', 'IN_PROGRESS', 'COMPLETE'] as const

export const siteMapStatusSchema = z.enum(SITE_MAP_STATUSES)

export type SiteMapStatus = z.infer<typeof siteMapStatusSchema>

export const SITE_MAP_STATUS_LABELS: Record<SiteMapStatus, string> = {
  NONE: 'No map',
  IN_PROGRESS: 'Map in progress',
  COMPLETE: 'Mapped',
}
